export const PAGES = "[Pages]";
